"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconHealthFilled = function IconHealthFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.61 11.9L38.11 10H37.89L29.39 11.89C29.2729 11.9181 29.1695 11.9867 29.0981 12.0837C29.0267 12.1807 28.992 12.2998 29 12.42L29.54 20C29.6742 21.8949 30.254 23.7312 31.2324 25.3595C32.2108 26.9878 33.5599 28.3619 35.17 29.37L37.73 30.97C37.8096 31.0242 37.9037 31.0531 38 31.0531C38.0963 31.0531 38.1904 31.0242 38.27 30.97L40.83 29.37C42.4401 28.3619 43.7892 26.9878 44.7676 25.3595C45.7459 23.7312 46.3258 21.8949 46.46 20L47 12.43C47.008 12.3098 46.9733 12.1907 46.9019 12.0937C46.8305 11.9967 46.7271 11.9281 46.61 11.9V11.9ZM42 21H39V24H37V21H34V19H37V16H39V19H42V21Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.9 35.37H43.6L43 35.46L32 37.05L31 36.62L29 35.76L25.58 34.3C25.4084 34.1882 25.2753 34.0265 25.1986 33.8366C25.1219 33.6468 25.1053 33.4379 25.1511 33.2384C25.1969 33.0388 25.3029 32.8581 25.4547 32.7207C25.6065 32.5832 25.7969 32.4958 26 32.47C26.1159 32.4713 26.2307 32.4916 26.34 32.53L29.05 33.53L31.05 34.28L31.31 34.38C31.5114 34.4553 31.725 34.4926 31.94 34.49C32.3146 34.4833 32.6775 34.3585 32.9771 34.1335C33.2766 33.9084 33.4975 33.5946 33.6084 33.2367C33.7192 32.8788 33.7142 32.4951 33.5942 32.1402C33.4742 31.7852 33.2453 31.4772 32.94 31.26L31 29.87C30.38 29.41 29.69 28.92 29 28.42L26.29 26.42C25.281 25.6803 24.1046 25.2019 22.8657 25.0274C21.6269 24.8529 20.3641 24.9878 19.19 25.42L15.52 26.79C15.1754 26.9226 14.8092 26.9904 14.44 26.99H9V25.49C9 25.3574 8.94732 25.2302 8.85355 25.1364C8.75979 25.0427 8.63261 24.99 8.5 24.99H3.5C3.36739 24.99 3.24021 25.0427 3.14645 25.1364C3.05268 25.2302 3 25.3574 3 25.49V38.49C3 38.6226 3.05268 38.7498 3.14645 38.8436C3.24021 38.9373 3.36739 38.99 3.5 38.99H8.5C8.63261 38.99 8.75979 38.9373 8.85355 38.8436C8.94732 38.7498 9 38.6226 9 38.49V36.99H14.59C14.8626 36.9918 15.133 37.0392 15.39 37.13L31 42.87C31.3374 42.9886 31.6924 43.0495 32.05 43.05C32.3899 43.0526 32.7279 42.9985 33.05 42.89L39.28 41.05L43 39.94L44.49 39.5C44.9731 39.3543 45.3879 39.0403 45.6594 38.6149C45.9308 38.1896 46.0408 37.681 45.9694 37.1815C45.8981 36.682 45.6501 36.2246 45.2704 35.8923C44.8907 35.5599 44.4046 35.3746 43.9 35.37Z",
    fill: color
  }));
};

IconHealthFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconHealthFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconHealthFilled;
exports.default = _default;